import { Col, FullScreenHeader, Row } from '@ahmdigital/ui';

import headerImage from '../../images/header.svg';

const PrivacySecurityHero = () => (
  <Row isBoxed>
    <Col df>
      <FullScreenHeader
        subtitle="When it comes to protecting your personal and health data, we’ve got your back."
        title="Security and privacy at ahm"
        scrollToNextElement
        scrollToElementText="Learn more about security and privacy"
        image={{ alt: '', src: headerImage.src }}
      />
    </Col>
  </Row>
);

export default PrivacySecurityHero;
